var _toConsumableArray = require("C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\xams.UI.Web.Player\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
var _classCallCheck = require("C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\xams.UI.Web.Player\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\xams.UI.Web.Player\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var floor = Math.floor;
var Unit = /*#__PURE__*/function () {
  "use strict";

  /**
   * Represents a time unit
   * @param {Number} magnitude - The number by which to multiply the unit to obtain its equivalent in the base unit (milliseconds).
   */
  function Unit(magnitude) {
    _classCallCheck(this, Unit);
    this.magnitude = magnitude;
  }

  /**
   * Convert base units (milliseconds) to this unit.
   * @param {Number} n - Number of base units (miliseconds) to be converted.
   * @returns {[Number, Number]} - The floored number of units, and the remainder in base unit.
   */
  _createClass(Unit, [{
    key: "convert",
    value: function convert(n) {
      var mag = this.magnitude;
      return [floor(n / mag), n % mag];
    }
    /**
     * Returns a function that converts this unit to a number of other units.
     * @param {...Function} units - Any number of units, in order, to which to convert this unit.
     * @returns {Function}
     */
  }, {
    key: "to",
    value: function to() {
      var _this = this;
      for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
        units[_key] = arguments[_key];
      }
      var mag = this.magnitude;
      /**
       * @param {Number} n - Number of this unit to be converted.
       * @returns {Array} - Each element corresponds to a unit, in the same order they were passed to `convert`
       */
      return function (n) {
        return units.reduce(function (arr, unit) {
          return [].concat(_toConsumableArray(arr.slice(0, -1)), _toConsumableArray(unit.convert(arr[arr.length - 1] * _this.magnitude)));
        }, [n]).slice(0, -1);
      };
      /* 
      ** The last element of the array always represents the base unit (miliseconds).
      ** For each unit, replace the last element of the result array by the number of units it contains,
      ** and carry the remainder, which is in milliseconds, as the last element.
      ** Finally, remove the last element (the last carried remainder).
      */
    }
    /**
     * Returns a function that converts a number of other units to this unit.
     * @param {...Function} units - Any number of units, in order.
     * @returns {Function}
     */
  }, {
    key: "from",
    value: function from() {
      var _this2 = this;
      for (var _len2 = arguments.length, units = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        units[_key2] = arguments[_key2];
      }
      /**
       * @param {...Number} - Number of units, in the same order they were passed to the `from` method.
       * @returns {Number} - A number of this unit.
       */
      return function () {
        for (var _len3 = arguments.length, ns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          ns[_key3] = arguments[_key3];
        }
        return units.reduce(function (sum, unit, i) {
          return sum + ns[i] * unit.magnitude;
        }, 0) / _this2.magnitude;
      };
    }
  }]);
  return Unit;
}();
var ms = milliseconds = new Unit(1);
var s = seconds = new Unit(1000);
var m = minutes = new Unit(1000 * 60);
var h = hours = new Unit(1000 * 60 * 60);
var d = days = new Unit(1000 * 60 * 60 * 24);
module.exports = {
  Unit: Unit,
  d: d,
  h: h,
  m: m,
  s: s,
  ms: ms,
  days: days,
  hours: hours,
  minutes: minutes,
  seconds: seconds,
  milliseconds: milliseconds
};